import { useMutation, useQueryClient } from '@tanstack/react-query';

import { fetchClient } from '@/lib/openapi-fetch/fetchClient';
import { notificationsEndpoints } from '@/modules/notifications/constants';
import { notificationsQueryKeys } from '@/modules/notifications/queries/queryKeys';

import { markReadInCache } from './markReadInCache';

export const useReadNotificationMutation = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (notificationId: string) => {
      const { data } = await fetchClient.PUT(
        notificationsEndpoints.readNotification,
        {
          params: { path: { id: notificationId } },
        },
      );
      return data;
    },
    onMutate: (notificationId: string) =>
      markReadInCache(
        queryClient,
        (notification) => notification.id === notificationId,
      ),
    onError: (_error, _notificationId, rollback) => rollback?.(),
    onSettled: () =>
      queryClient.invalidateQueries({
        queryKey: notificationsQueryKeys.list(),
      }),
  });
};
